<template>
  <div
    v-if="elementSidebar"
    class="wf-flex wf-flex-wrap wf-fixed"
    style="width:320px"
  >
    <div class="wf-z-20 wf-flex wf-flex-col wf-top-0 wf-right-0 wf-w-20 wf-bg-blue-500 wf-min-h-screen">
      <div class="wf-flex wf-items-center wf-justify-center">
        <span class="wf-w-full wf-h-16 wf-flex wf-flex-col wf-items-center wf-justify-center">
          <i :class="icon" class="fas wf-text-sm wf-text-white"></i>
          <p class="wf-mt-1 wf-text-xxs wf-text-white" v-text="title"></p>
        </span>
      </div>
      <div v-for="property in elementProperties" :key="property" class="wf-flex wf-items-center wf-justify-center">
        <button
          @click.prevent="openSelectedProperty(property)"
          class="wf-w-full wf-h-20 focus:wf-outline-none"
          :class="property == openProperty ? ['wf-bg-blue-600'] : ['hover:wf-bg-blue-600']"
        >
          <p class="wf-text-xxs wf-text-white" v-text="property"></p>
        </button>
      </div>
    </div>
    <div class="wf-flex-1 wf-bg-gray-100 wf-p-4">
      <component
        :key="property.key"
        v-for="property in openProperties"
        :is="property.component"
        :text="property.text"
        :property="property.property"
        :element="element"
        :items="property.items"
        :dataSlider="property.dataSlider"
        :module="module"
        :only="property.only"
        :except="property.except"
        :classes="property.class"
        :styles="property.styles"
        :parentModule="parentModule"
      />
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        openProperty: null,
      }
    },
    watch: {
      element() {
        this.openProperty = null
      },
      openProperty(value) {
        if (! value) {
          return
        }
        this.registerComponents()
      }
    },
    computed: {
      parentModule() {
        return this.$store.state.parentModule
      },
      customClasses() {
        return this.$store.getters[`${this.module}/elements`](this.element, this.parentModule).customClasses
      },
      openProperties() {
        return this.$store.getters[`${this.module}/properties`](this.element, this.parentModule)[this.openProperty]
      },
      elementSidebar() {
        return this.$store.getters['settingsModule/elementSidebar']
      },
      elementObject() {
        return this.$store.getters[`${this.module}/elements`](this.element, this.parentModule)
      },
      elementProperties() {
        if (! this.elementObject) {
          return []
        }
        return Object.keys(this.elementObject.properties).filter(property => property != 'menu' && this.elementObject.properties[property].length != 0)
      },
      title() {
        return this.module.substr(0, this.module.indexOf('Module'))
      },
      icon() {
        return 'fa-th-large'
      },
      id() {
        console.log(this.module, this.element, this.parentModule)
        return this.$store.getters[`${this.module}/id`](this.element, 'id', this.parentModule)
      },
      element() {
        return this.$store.state.editingElement
      },
      module() {
        return this.$store.state.editingModule
      },
      elementToolbar() {
        return this.$store.state.elementToolbar
      }
    },
    methods: {
      openSelectedProperty(property) {
        if (property == this.openProperty) {
          this.openProperty = null
          return this.$store.commit('toggleElementToolbar', {
            element: this.element,
            module: this.module,
            open: false,
            parentModule: this.parentModule
          })
        }
        this.openProperty = property
        if (! this.elementToolbar) {
          this.$store.commit('toggleElementToolbar', {
            element: this.element,
            module: this.module,
            open: true,
            parentModule: this.parentModule
          })
        }
      },
      registerComponents() {
        this.openProperties.forEach(property => this.$set(this.$options.components, property.component, () => import(`../MenuProperties/${property.component}.vue`)))
      },
    }
  }
</script>